import React from 'react';

const CatalogSkeleton = () => {
    return (
        <>
            {Array.from({ length: 8 }).map((_, index) => (
                <div key={index} className='flex flex-col overflow-hidden rounded-lg border border-N200 bg-white shadow-elevation1'>
                    <div className='h-44 animate-pulse bg-sky-50 sm:h-48' />
                    <div className='space-y-2 p-4'>
                        <div className='h-3 w-20 animate-pulse rounded bg-N100' />
                        <div className='h-4 w-full animate-pulse rounded bg-N100' />
                        <div className='h-4 w-2/3 animate-pulse rounded bg-N100' />
                    </div>
                    <div className='flex items-center justify-between border-t border-N100 bg-N50/70 px-4 py-3'>
                        <div className='h-5 w-24 animate-pulse rounded bg-N100' />
                        <div className='h-8 w-20 animate-pulse rounded-lg bg-N100' />
                    </div>
                </div>
            ))}
        </>
    );
};

export default CatalogSkeleton;
